/* eslint-disable no-unused-vars */
/* eslint-disable indent */
import React, { useState, useEffect } from "react";
import { Col, Input, Form, AutoComplete, message } from "antd";
import {
  checkNumbervalue,
  preventTextPaste,
  validateNumberMinValue,
} from "../../../utils";

function DoxAndNonDox({
  isNonDox,
  form,
  ewayBillValueCheck,
  shipmentContentOptions,
  childShipments,
  // handleOnEnter,
  nonDoxValueReq,
  setNonDoxValueReq,
  handleTabEnter,
  disableEdit,
  editShipmentDetails,
}) {
  const [childWeight, setChildWeight] = useState({
    child: 0,
    total: 0,
    totalVol: 0,
    totalVolChild: 0,
  });

  useEffect(() => {
    let totalChild = childShipments?.reduce(
      (sum, item) => +sum + parseFloat(item?.weight),
      0
    );
    let totalVolChild = childShipments?.reduce(
      (sum, item) => +sum + parseFloat(item?.volumetricWeight),
      0
    );

    setChildWeight({
      total: +form.getFieldValue("weight"),
      totalVol: +form.getFieldValue("volumetricWeight") || 0,
      child: +totalChild,
      totalVolChild: +totalVolChild?.toFixed(2),
    });
  }, [childShipments]);

  const volumCalculation = (e) => {
    // console.log(e.target.value, "e");
    let data = e?.target?.value;
    if (data?.length == 0) {
      setChildWeight((prev) => ({
        ...prev,
        child: +childWeight?.child,
        totalVolChild: +childWeight?.totalVolChild,
        totalVol: +childWeight?.totalVol,
      }));
      return;
    }

    const { length, width, height } = form.getFieldValue();
    const volume = ((+length * +width * +height) / 5000)?.toFixed(2);
    if (volume) {
      form.setFieldsValue({
        volumetricWeight: volume,
      });
    }
    let totalChild = childShipments?.reduce(
      (sum, item) => +sum + parseFloat(item?.weight),
      0
    );
    let totalVolChild = childShipments?.reduce(
      (sum, item) => +sum + parseFloat(item?.volumetricWeight),
      0
    );

    setChildWeight({
      total: +form.getFieldValue("weight") || 0,
      child: +totalChild || 0,
      totalVolChild: +totalVolChild?.toFixed(2) || 0,
      totalVol: +volume || 0,
    });
  };

  const autoCompleteOptions = shipmentContentOptions?.map((option) => ({
    value: option?.shipmentContentName,
    label: option?.shipmentContentName,
  }));

  function handleOnEnter(event, name) {
    // console.log(name, "NAME");

    event.preventDefault();

    const targetElement__ = event?.target;
    // let currentValue = targetElement__?.value?.trim();
    const selectedInputName = event?.target?.id;

    const allowEmptyIds = ["length", "width", "height"];

    if (allowEmptyIds.includes(selectedInputName)) {
      handleTabEnter(event);
      return;
    }

    const currentValue = form.getFieldValue(selectedInputName);

    if (!currentValue) {
      form.setFields([
        {
          name: selectedInputName,
          errors: ["Enter " + selectedInputName],
        },
      ]);

      return;
    }

    handleTabEnter(event);
  }

  return (
    <>
      {!isNonDox ? (
        <>
          <Col lg={9} sm={9} md={9}>
            <Form.Item
              name="content"
              label="Content"
              rules={[
                {
                  required: true,
                  message: "Select content",
                },
              ]}
            >
              {/* <AutoComplete
                options={autoCompleteOptions}
                placeholder="Select a content"
                optionFilterProp="children"
                filterOption={(inputValue, option) =>
                  option.value
                    .toUpperCase()
                    .indexOf(inputValue.toUpperCase()) !== -1
                }
              /> */}

              <AutoComplete
                showAction={["focus", "click"]}
                // defaultActiveFirstOption
                options={autoCompleteOptions}
                placeholder="Select content"
                onInput={(e) =>
                  (e.target.value = e?.target?.value?.toUpperCase() || "")
                }
                // onSelect={handleTabEnter}
                filterOption={(inputValue, option) =>
                  option?.value
                    ?.toUpperCase()
                    ?.indexOf(inputValue?.toUpperCase()) !== -1
                }
                // maxLength={50}
                onKeyDown={(event) => {
                  if (event.key == "Enter") {
                    handleOnEnter(event, "value");
                  }
                }}
              />
            </Form.Item>
          </Col>
          <div style={{ width: "8%" }}>
            <Form.Item
              name="value"
              label={
                <span className="calculater-container-pikpin">Value (INR)</span>
              }
              rules={[
                {
                  pattern: /^[0-9].*/g,
                  message: "Enter value.",
                },
                () => ({
                  validator(rule, value = "") {
                    if (value?.toString()?.startsWith("0") && value !== "0") {
                      return Promise.reject("Invalid value");
                    } else {
                      return Promise.resolve();
                    }
                  },
                }),
              ]}
              onKeyPress={(event) => {
                if (event.key == "Enter") {
                  event?.preventDefault();
                  handleTabEnter(event);
                }
                const input = event?.target?.value;
                if (input?.includes(".") && input?.split(".")[1]?.length >= 2) {
                  event.preventDefault(); // Block additional digits after 2 decimal places
                }
              }}
            >
              <Input
                placeholder="value"
                maxLength={15}
                type="number"
                onInput={(e) => preventTextPaste(e, 15)}
                onChange={(e) =>
                  +e.target.value > 50000
                    ? ewayBillValueCheck(true)
                    : ewayBillValueCheck(false)
                }
              />
            </Form.Item>
          </div>
          <Col lg={3} sm={3} md={3}>
            <Form.Item
              label="Weight(Gms)"
              name="weight"
              initialValue={50}
              rules={[
                {
                  required: true,
                  message: "Enter weight",
                },
                () => ({
                  validator(_, value) {
                    if (!value && !value?.length) {
                      return Promise.reject();
                    }

                    if (value?.length) {
                      if (value < 50) {
                        return Promise.reject("Min weight: 50 Gm");
                      }
                      if (disableEdit) {
                        if (
                          +value < +editShipmentDetails?.shipmentDetails?.weight
                        ) {
                          // message.error("Weight cannot be lower then original");
                          return Promise.reject(
                            "Updated Weight cannot be less than previously added weight" +
                              "(" +
                              editShipmentDetails?.shipmentDetails?.weight +
                              "gms)"
                          );
                        }
                      }

                      if (parseInt(value?.substring(1, 0)) === 0) {
                        return Promise.reject("Weight cannot be zero");
                      }

                      if (value && value?.split(".")?.length > 2) {
                        return Promise.reject("Enter only one decimal");
                      }

                      if (value > 10000) {
                        return Promise.reject("Max weight: 10000 Gm");
                      }
                    }
                    return Promise.resolve();
                  },
                }),
              ]}
              onKeyPress={(event) => {
                if (event.key == "Enter") {
                  handleOnEnter(event, "insured");
                  // document.getElementById("submit_credit").blur();
                }
              }}
            >
              <Input
                type="number"
                disabled={disableEdit}
                maxLength={7}
                onInput={(e) => preventTextPaste(e, 7)}
                placeholder="Enter weight"
                // min={1}
              />
            </Form.Item>
          </Col>
        </>
      ) : (
        <>
          <Col lg={10} sm={10} md={10}>
            <Form.Item
              name="content"
              label="Non-Dox Content"
              rules={[
                {
                  required: true,
                  message: "Select content",
                },
              ]}
            >
              <AutoComplete
                showAction={["focus", "click"]}
                onChange={(e) => {
                  if (e?.trim() == "SAMPLE") {
                    setNonDoxValueReq(false);
                  } else {
                    setNonDoxValueReq(true);
                  }
                }}
                options={autoCompleteOptions}
                onInput={(e) =>
                  (e.target.value = e?.target?.value?.toUpperCase() || "")
                }
                // onSelect={handleTabEnter}
                // defaultActiveFirstOption
                placeholder="Select content"
                filterOption={(inputValue, option) =>
                  option?.value
                    ?.toUpperCase()
                    ?.indexOf(inputValue?.toUpperCase()) !== -1
                }
                onKeyDown={(event) => {
                  if (event.key == "Enter") {
                    handleOnEnter(event, "weight");
                  }
                }}
              />
            </Form.Item>
          </Col>

          <Col lg={5} sm={6} md={5}>
            <Form.Item
              extra={
                childShipments?.length ? (
                  <div style={{ fontSize: "11px", color: "rgb(80, 205, 137)" }}>
                    <span>
                      Child wt:
                      <span>{childWeight?.child + " kg"}</span>
                    </span>{" "}
                    <span>
                      Total wt:{" "}
                      {(+childWeight?.total + +childWeight?.child)?.toFixed(2) +
                        " kg"}
                    </span>
                  </div>
                ) : null
              }
              label={
                <span className="calculater-container-pikpin">
                  {childShipments?.length ? "Parent weight(Kg)" : "Weight (Kg)"}
                </span>
              }
              name="weight"
              rules={[
                {
                  required: true,
                  // maxLength: 3,
                  message: "Enter weight",
                },
                // {
                //   pattern: /^(?!0)(\d+(\.\d{1,2})?)?$/,
                //   message: "Enter weight of at least 1 kg",
                // },
                () => ({
                  validator(_, value) {
                    if (!value && !value?.length) {
                      return Promise.reject();
                    }

                    const stringValue = String(value);

                    if (
                      parseFloat(value) === 0.0 ||
                      value === 0 ||
                      value === "0" ||
                      value === ".0"
                    ) {
                      return Promise.reject("Min weight: 0.1");
                    }

                    if (/^0\.0{2,}/.test(stringValue)) {
                      return Promise.reject("Invalid value");
                    }

                    if (stringValue && stringValue?.split(".")?.length > 2) {
                      return Promise.reject("Only one decimal allowed");
                    }

                    if (disableEdit) {
                      if (
                        +stringValue <
                        +editShipmentDetails?.shipmentDetails?.weight
                      ) {
                        return Promise.reject(
                          "Updated Weight cannot be less than previously added weight " +
                            "(" +
                            editShipmentDetails?.shipmentDetails?.weight +
                            "kg )"
                        );
                      }
                    }
                    if (value > 499.99) {
                      return Promise.reject("Max weight: 499 kg");
                    }
                    return Promise.resolve();
                  },
                  //validateTrigger: "onSubmit",
                }),
              ]}
              onKeyPress={(event) => {
                if (event.key == "Enter") {
                  handleOnEnter(event, "length");
                } else if (checkNumbervalue(event)) {
                  event.preventDefault();
                }
              }}
            >
              <Input
                id="weight"
                disabled={disableEdit}
                placeholder="Enter weight"
                maxLength={6}
                onChange={volumCalculation}
                // type="number"
                onInput={(e) => preventTextPaste(e, 6)}
                // min={1}
              />
            </Form.Item>
          </Col>

          <Col lg={3} sm={6} md={3}>
            <Form.Item
              label={"Length(Cm)"}
              name="length"
              rules={[
                {
                  required: false,
                  message: "Enter length",
                },
                // validateNumberMinValue("cannot be 0")(),
              ]}
              onKeyPress={(event) => {
                if (event.key == "Enter") {
                  handleOnEnter(event, "width");
                } else if (checkNumbervalue(event) || event.key === ".") {
                  event.preventDefault();
                }
              }}
            >
              <Input
                placeholder="Enter length"
                maxLength={3}
                type="number"
                onInput={(e) => preventTextPaste(e, 3)}
                onChange={volumCalculation}
                disabled={disableEdit}
              />
            </Form.Item>
          </Col>
          <Col lg={3} sm={6} md={3}>
            <Form.Item
              label="Width(Cm)"
              name="width"
              rules={[
                {
                  required: false,
                  message: "Enter width",
                },
                // validateNumberMinValue("cannot be 0")(),
              ]}
              onKeyPress={(event) => {
                if (event.key == "Enter") {
                  handleOnEnter(event, "height");
                } else if (checkNumbervalue(event) || event.key === ".") {
                  event.preventDefault();
                }
              }}
            >
              <Input
                placeholder="Enter width"
                onChange={volumCalculation}
                maxLength={3}
                type="number"
                onInput={(e) => preventTextPaste(e, 3)}
                disabled={disableEdit}
              />
            </Form.Item>
          </Col>
          <Col lg={3} sm={6} md={3}>
            <Form.Item
              label={
                <span className="calculater-container-pikpin">Height (Cm)</span>
              }
              name="height"
              rules={[
                {
                  required: false,
                  message: "Enter height",
                },
                // validateNumberMinValue("cannot be 0")(),
              ]}
              onKeyPress={(event) => {
                if (event.key == "Enter") {
                  handleOnEnter(event, "value");
                } else if (checkNumbervalue(event) || event.key === ".") {
                  event.preventDefault();
                }
              }}
            >
              <Input
                placeholder="Enter height"
                maxLength={3}
                type="number"
                onInput={(e) => preventTextPaste(e, 3)}
                onChange={volumCalculation}
                disabled={disableEdit}
              />
            </Form.Item>
          </Col>

          <Col lg={6} sm={9} md={9}>
            <Form.Item
              label="Vol weight (Kg)"
              name="volumetricWeight"
              dependencies={["length", "width", "height"]}
              validateTrigger={["onChange", "onBlur"]}
              rules={[
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    let currentWeight =
                      +editShipmentDetails?.shipmentDetails?.volumetricWeight;

                    if (
                      +form.getFieldValue("volumetricWeight") <
                        +currentWeight &&
                      disableEdit
                    ) {
                      form.setFields([
                        {
                          name: "volumetricWeight",
                          errors: [
                            `Updated Weight cannot be less than previously added
                          weight (${currentWeight} kg)`,
                          ],
                        },
                      ]);
                      return Promise.reject(
                        `Updated Weight cannot be less than previously added
                          weight (${currentWeight} kg)`
                      );
                    }
                    return Promise.resolve();
                  },
                }),
              ]}
              extra={
                childShipments?.length ? (
                  <div style={{ fontSize: "11px", color: "rgb(80, 205, 137)" }}>
                    <span>
                      Child wt: <span>{+childWeight?.totalVolChild} kg</span>
                    </span>{" "}
                    <span>
                      Total wt:{" "}
                      {(
                        +childWeight?.totalVol + +childWeight?.totalVolChild
                      )?.toFixed(2)}{" "}
                      kg
                    </span>
                  </div>
                ) : null
              }
            >
              <Input type="number" disabled />
            </Form.Item>
          </Col>
          <Col lg={3} sm={6} md={3}>
            <Form.Item
              name="value"
              label={
                <span className="calculater-container-pikpin">Value (INR)</span>
              }
              rules={[
                {
                  required: nonDoxValueReq,
                  message: "Enter value",
                },
                {
                  pattern: /^[0-9].*/g,
                  message: "Enter value",
                },
                () => ({
                  validator(rule, value = "") {
                    if (parseInt(value?.toString()?.substring(1, 0)) === 0) {
                      return Promise.reject("Invalid value");
                    } else {
                      return Promise.resolve();
                    }
                  },
                }),
              ]}
              onKeyPress={(event) => {
                if (event.key === "Enter") {
                  event?.preventDefault();
                  const currentValue = event?.target?.value?.trim();
                  if (nonDoxValueReq) {
                    if (!currentValue) {
                      form.setFields([
                        {
                          name: "value",
                          errors: ["Enter value"],
                        },
                      ]);
                      return;
                    }
                  }
                  handleTabEnter(event);
                } else if (checkNumbervalue(event)) {
                  event.preventDefault();
                }
              }}
            >
              <Input
                placeholder="Enter value"
                maxLength={15}
                type="number"
                onInput={(e) => preventTextPaste(e, 15)}
                onChange={(e) =>
                  +e.target.value > 50000
                    ? ewayBillValueCheck(true)
                    : ewayBillValueCheck(false)
                }
              />
            </Form.Item>
          </Col>
        </>
      )}
    </>
  );
}

export default DoxAndNonDox;
